import React, { useEffect, useState } from "react";
import axios from "axios";
import { useAuthContext } from "../../hooks/useAuthContext";
import { useNavigate } from "react-router-dom";
import { ApiConnectionString } from "../../constants/ApiConntection";
import OnBoaringMainPage from "../Onboarding/OnBoaringMainPage";
import ClubInfoForm from "./ClubInfoForm";
import ClubImages from "./ClubImages";
import PaymentOptions from "./PaymentOptions";
import Products from "./Products";
import Review from "./Review";
import LoadingSpinner from "../../components/LoadingSpinner";
import Classes from "./Classes";

export default function CreateClub() {
  //hooks
  const { user } = useAuthContext();

  //myprofile
  const [appUser, setAppUser] = useState([]);

  const [isLoading, setIsLoading] = useState(true);

  const [pendingclub, setPendingClub] = useState(null);
  const [enabled, setEnabled] = useState(false);

  const enableAccount = () => {
    setEnabled(true)
  }

  const reviewAppUser = async () => {
    // Fetch user data
    const userResponse = await axios.get(
      `${ApiConnectionString}/api/user/myprofile`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (userResponse.status == 200) {
      setAppUser(userResponse.data);
      if (userResponse.data.stripeAccount) {
        reviewPendingClub();
      }
    }
  };

  const getAccount = async () => {
    try {
      const createAccRespose = await axios.get(
        `${ApiConnectionString}/api/ConnectAccount`,
        {
          headers: { Authorization: `Bearer ${user.token}` },
        }
      );

      if (createAccRespose.status == 200) {
        if (createAccRespose.data == "Account is enabled and ready to use") {
          setEnabled(true);
        }
      }
    } catch (error) {
      console.error("Error fetching account:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (user) {
      reviewAppUser();
    }
  }, [user]);

  useEffect(() => {
    if (appUser.stripeAccount) {
      getAccount();
    }else{
      setIsLoading(false)
    }
  }, [appUser]);

  const reviewPendingClub = async () => {
    const pendingClubResposne = await axios.get(
      `${ApiConnectionString}/api/pendingclub`,
      {
        headers: { Authorization: `Bearer ${user.token}` },
      }
    );

    if (pendingClubResposne.status == 200) {
      setPendingClub(pendingClubResposne.data);
    }
  };

  const [currentView, setCurrentView] = useState("clubInfo");

  const changeView = (e) => {
setCurrentView(e)
  }

  const renderComponent = () => {
    switch (currentView) {
      case "clubInfo":
        return (
          <ClubInfoForm
            pendingclub={pendingclub}
            reviewPendingClub={reviewPendingClub}
            changeView={changeView}
          />
        );

      case "clubImages":
        return (
          <ClubImages
            pendingclub={pendingclub}
            reviewPendingClub={reviewPendingClub}
               changeView={changeView}
          />
        );
      case "classes":
        return (
          <Classes
            pendingclub={pendingclub}
            reviewPendingClub={reviewPendingClub}
               changeView={changeView}
          />
        );
      case "paymentOptions":
        return (
          <Products
            pendingclub={pendingclub}
            reviewPendingClub={reviewPendingClub}
               changeMainView={changeView}
          />
        );
      case "review":
        return (
          <Review
            pendingclub={pendingclub}
            reviewPendingClub={reviewPendingClub}
               changeView={changeView}
          />
        );
      default:
        return null;
    }
  };

  if (!isLoading) {
    if (appUser) {
      if (!enabled) {
        return <OnBoaringMainPage enableAccount={enableAccount} />;
      } else if (pendingclub) {
        return (
          <div className="container mt-4 bg-white p-2 rounded">
       
              <h2 className="blueText text-center fw-bold">
                Club Creation
              </h2>
   

            {/* <div className="hideAt800">
              <div className="d-flex justify-content-end hideAt800">
           
                <div
                  onClick={() => setCurrentView("clubInfo")}
                  className="large-menu-button"
                >
                  <div>
                    <span>Club Information</span>{" "}
                  </div>
                  {pendingclub.detailsSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>

                <div
                  onClick={() => setCurrentView("clubImages")}
                  className="large-menu-button"
                >
                  <div>
                    <span>Club Images</span>{" "}
                  </div>
                  {pendingclub.imagesSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>
                <div
                  onClick={() => setCurrentView("classes")}
                  className="large-menu-button"
                >
                  <div>
                    <span>Classes</span>{" "}
                  </div>
                  {pendingclub.classesSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>
                <div
                  onClick={() => setCurrentView("paymentOptions")}
                  className="large-menu-button"
                >
                  <div>
                    <span>Payment Options</span>{" "}
                  </div>
                  {pendingclub.paymmentOptionsSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>
                <div
                  onClick={() => setCurrentView("review")}
                  className="large-menu-button"
                >
                  <div>
                    <span>Review And Submit</span>{" "}
                  </div>
                </div>
    
              </div>
            </div> */}

            {/* <div className="showAt800">
              <div className="">
          
                <div
                  onClick={() => setCurrentView("clubInfo")}
                  className="settings-menu-button-stacked"
                >
                  <div>
                    <span>Club Information</span>{" "}
                  </div>
                  {pendingclub.detailsSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>

                <div
                  onClick={() => setCurrentView("clubImages")}
                  className="settings-menu-button-stacked"
                >
                  <div>
                    <span>Club Images</span>{" "}
                  </div>
                  {pendingclub.imagesSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>
          
                <div
                  onClick={() => setCurrentView("classes")}
                  className="settings-menu-button-stacked"
                >
                  <div>
                    <span>Classes</span>{" "}
                  </div>
                  {pendingclub.classesSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>
         
                <div
                  onClick={() => setCurrentView("paymentOptions")}
                  className="settings-menu-button-stacked"
                >
                  <div>
                    <span>Payment Options</span>{" "}
                  </div>
                  {pendingclub.paymmentOptionsSubmitted ? (
                    <p className="text-success">Complete</p>
                  ) : (
                    <p>Incomplete</p>
                  )}
                </div>
               
                <div
                  onClick={() => setCurrentView("review")}
                  className="settings-menu-button-stacked"
                >
                  <div>
                    <span>Review And Submit</span>{" "}
                  </div>
                </div>
               
              </div>
            </div> */}

            <div className="mt-3">{renderComponent()}</div>
          </div>
        );
      }
    }
  } else {
    return (
      <div>
        <LoadingSpinner />
      </div>
    );
  }
}
